/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DelegationNotificationsStatusChange,
    DelegationNotificationsStatusChangeFromJSON,
    DelegationNotificationsStatusChangeFromJSONTyped,
    DelegationNotificationsStatusChangeToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationNotificationsStatusChangeResponse
 */
export interface DelegationNotificationsStatusChangeResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof DelegationNotificationsStatusChangeResponse
     */
    msg: string;
    /**
     * 
     * @type {DelegationNotificationsStatusChange}
     * @memberof DelegationNotificationsStatusChangeResponse
     */
    entry: DelegationNotificationsStatusChange;
}

export function DelegationNotificationsStatusChangeResponseFromJSON(json: any): DelegationNotificationsStatusChangeResponse {
    return DelegationNotificationsStatusChangeResponseFromJSONTyped(json, false);
}

export function DelegationNotificationsStatusChangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationNotificationsStatusChangeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': DelegationNotificationsStatusChangeFromJSON(json['entry']),
    };
}

export function DelegationNotificationsStatusChangeResponseToJSON(value?: DelegationNotificationsStatusChangeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': DelegationNotificationsStatusChangeToJSON(value.entry),
    };
}


